/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Skip custom extension confirmation",
  "description": "Loads the custom extensions used by a project without showing the security prompt. Only enable this if you trust every project you open.",
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "dynamicDisable": true,
  "tags": [
    "danger"
  ],
  "enabledByDefault": false
};
export default manifest;
